export const useCosmo = defineStore('cosmo', {
  state: () => ({
    showChatbot: false,
    conversation: [],
    dismissed: false,
    sessionId: null
  }),
  actions: {
    setConversation(conversation) {
      this.conversation = conversation;
    },
    setMessageVote(messageId, vote) {
      const message = this.conversation.find((message) => message.id === messageId);
      if (message) {
        message.vote = vote;
      }
    },
    setSessionId(sessionId) {
      this.sessionId = sessionId;
    },
    toggleChatbot() {
      if (!this.dismissed) {
        this.dismissed = true;
      }
      this.showChatbot = !this.showChatbot;
    },
    setCosmoDismissed() {
      this.dismissed = true;
    },
    reset() {
      this.conversation = [];
    }
  },
  getters: {
    isOpen: (state) => state.showChatbot,
    conversationBreakdown: (state) => {
      return {
        assistant: state.conversation?.filter((message) => message.role === 'assistant'),
        user: state.conversation?.filter((message) => message.role === 'user'),
      }
    }
  },
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage()
  }
});
